import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const EmotionCacheProvider = ({ children }: { children: React.ReactNode }) => {
  const emotionCache = createCache({ key: 'insight', speedy: false });

  return <CacheProvider value={emotionCache}>{children}</CacheProvider>;
};

export default EmotionCacheProvider;
